import React from 'react';

import EditOrganization from 'screens/organizations/components/EditOrganization';
import {
  ManageOrganizationWrapper,
  EditOrganizationProviderWrapper
} from 'screens/organizations/context/EditOrganizationProvider';

const EditOrganizationScreen = () => <EditOrganization />;

export default EditOrganizationScreen;

EditOrganizationScreen.getLayout = (page) => (
  <ManageOrganizationWrapper>
    <EditOrganizationProviderWrapper>{page}</EditOrganizationProviderWrapper>
  </ManageOrganizationWrapper>
);
